module.exports = __webpack_public_path__ + "static/media/movie-a-quiet-place.ce70909b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/movies/movie-a-quiet-place.jpg
// module id = 30
// module chunks = 0